import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export default function SmoothDropdownButton({ onClick, open }: { onClick: () => void; open?: boolean }) {
  return (
    <IconButton
      size="small"
      onClick={onClick}
      sx={{
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.3s"
      }}
    >
      <ExpandMoreIcon />
    </IconButton>
  );
}
